import { createSlice } from "@reduxjs/toolkit";
import { useEffect } from "react";
import axiosconfig from "../../Service/axiosConfig"

// const fetchUpdteProducts = async (id) => {
//   const Responce = await axiosconfig.get(`/catlog/products/${id}/?store=${localStorage.getItem("storeId")}`)
//   return Responce.data;
// }

const getLocaData = async () => {
  const newData = localStorage.getItem("state");
  let cartData = JSON.parse(newData);
  let total = 0;
  if (newData === null) {
    return {
      products: [],
      total: 0,
    };
  } else {
    if (cartData.length > 0) {
      for (let i = 0; i < cartData.length; i++) {
        const res = cartData[i];
        const activePriceObj = res.selectedPackage || res;
        const basePrice =
          activePriceObj.offer_price > 0
            ? activePriceObj.offer_price
            : activePriceObj.price;

        total += res.quantity * basePrice;
      }
    }
    console.log(total)
    const rentCartData = localStorage.getItem("rentCart");
    const rentCartParsed = rentCartData ? JSON.parse(rentCartData) : [];
    
    return {
      products: cartData,
      rentCart: rentCartParsed,
      total: total,
    };
  }
};

const getLocaTotal = (state) => {
  const NewData = localStorage.getItem("total")
  if (NewData === null) {
    return 0
  }
  else {
    console.log(NewData)
    return parseFloat(NewData)

  }
}
// const getLocalWishlists = (state) => {
//   const NewData = localStorage.getItem("wishlists")
//   if (NewData === null) {
//     return []
//   }
//   else {
//     return JSON.parse(NewData)
//   }
// }
const initialState = {
  products: [],
  rentCart: [],
  // wishlists: getLocalWishlists(),
  wishlists: [],
  total: 0,
  wishlists : [],
};
export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setRentCart: (state, action) => {
      state.rentCart = action.payload;
    },
    setTotal: (state, action) => {
      state.total = action.payload;
    },
    setWishLists : (state, action) => {
      state.wishlists = action.payload
    },
    addProduct: (state, action) => {
      const { product, quantity } = action.payload;
      const existingProduct = state.products.find((p) => p.id === product.id);
      if (existingProduct) {
        existingProduct.quantity += quantity
      } else {
        state.products.push({ ...product, quantity });
      }
      console.log(product, state)
      const activePriceObj = product.selectedPackage || product;
      const basePrice = activePriceObj.offer_price > 0 ? activePriceObj.offer_price : activePriceObj.price;
      const totalPrice = parseFloat(basePrice) + (isNaN(product.variant_Price) ? 0 : product.variant_Price);
      state.total += quantity * totalPrice;
      console.log(state.total, quantity, parseFloat(basePrice), product.offer_price, totalPrice, "total")
      localStorage.setItem("total", state.total)
      localStorage.setItem("state", JSON.stringify(state.products))
    },
    /* ── Rent cart: each rental configuration is a unique line item by cartItemId ── */
    addToRentCart: (state, action) => {
      // action.payload is a full rental cart item with a unique cartItemId
      const item = action.payload;
      const existing = state.rentCart.find((r) => r.cartItemId === item.cartItemId);
      if (!existing) {
        state.rentCart.push({ ...item });
        localStorage.setItem("rentCart", JSON.stringify(state.rentCart));
      }
    },
    removeFromRentCart: (state, action) => {
      // action.payload is the cartItemId string to remove
      state.rentCart = state.rentCart.filter((r) => r.cartItemId !== action.payload);
      localStorage.setItem("rentCart", JSON.stringify(state.rentCart));
    },
    clearRentCart: (state) => {
      state.rentCart = [];
      localStorage.removeItem("rentCart");
    },
    addWishlist: (state, action) => {
      const { productId, wish_id, type } = action.payload;

      const existingProduct = state.wishlists.find((p) => p.id === productId && p.type === type);
      if (!existingProduct) {
        state.wishlists.push({ id: productId, wish_id, type });
      }
    },

    removeWishlist: (state, action) => {
      const { productId, type } = action.payload;

      const productIndexToRemove = state.wishlists.findIndex(
        (p) => p.id === productId && p.type === type
      );

      if (productIndexToRemove !== -1) {
        state.wishlists = state.wishlists.filter(
          (p) => !(p.id === productId && p.type === type)
        );
      }
    },
    clearWishlist: (state) => {
      state.wishlists = [];
    },
    removeProduct: (state, action) => {
      const { productId, quantity } = action.payload;
      const existingProduct = state.products.find((p) => p.id === productId);

      if (existingProduct) {
        if (existingProduct.quantity > quantity) {
          existingProduct.quantity -= quantity;
          const activePriceObj = existingProduct.selectedPackage || existingProduct;
          const basePrice = activePriceObj.offer_price > 0 ? activePriceObj.offer_price : activePriceObj.price;
          const totalPrice = parseFloat(basePrice) + (isNaN(existingProduct.variant_Price) ? 0 : existingProduct.variant_Price);
          state.total -= quantity * totalPrice;
          localStorage.setItem("total", state.total)
          localStorage.setItem("state", JSON.stringify(state.products))
        } else {
          state.products = state.products.filter((p) => p.id !== productId);
          const activePriceObj = existingProduct.selectedPackage || existingProduct;
          const basePrice = activePriceObj.offer_price > 0 ? activePriceObj.offer_price : activePriceObj.price;
          const totalPrice = parseFloat(basePrice) + (isNaN(existingProduct.variant_Price) ? 0 : existingProduct.variant_Price);
          state.total -= quantity * totalPrice;
          localStorage.setItem("total", state.total)
          localStorage.setItem("state", JSON.stringify(state.products))
        }
      }
    },
    clearCart: (state) => {
      state.products = [];
      state.total = 0;
      state.wishlists = [];
      state.rentCart = [];
      localStorage.removeItem("state");
      localStorage.removeItem("total");
      localStorage.removeItem("rentCart");
    },
    updateProductPackage: (state, action) => {
      const { productId, packageData } = action.payload;
      const product = state.products.find((p) => p.id === productId);
      if (product) {
        const oldActiveObj = product.selectedPackage || product;
        const oldBasePrice = oldActiveObj.offer_price > 0 ? oldActiveObj.offer_price : oldActiveObj.price;
        const oldTotalPrice = parseFloat(oldBasePrice) + (isNaN(product.variant_Price) ? 0 : product.variant_Price);

        state.total -= product.quantity * oldTotalPrice;

        product.selectedPackage = packageData;

        const newActiveObj = product.selectedPackage || product;
        const newBasePrice = newActiveObj.offer_price > 0 ? newActiveObj.offer_price : newActiveObj.price;
        const newTotalPrice = parseFloat(newBasePrice) + (isNaN(product.variant_Price) ? 0 : product.variant_Price);

        state.total += product.quantity * newTotalPrice;

        localStorage.setItem("total", state.total);
        localStorage.setItem("state", JSON.stringify(state.products));
      }
    },
  },

});
export const selectCartProducts = state => state.cart.products
// export const selectWishlists = state => state.cart.Wishlists
export const selectWishlists = state => state.cart.wishlists
export const selectCartTotal = state => state.cart.total
export const selectRentCart = state => state.cart.rentCart

export const { addProduct, removeProduct, clearCart, addWishlist, clearWishlist, removeWishlist, setProducts, setRentCart, setTotal, updateProductPackage, addToRentCart, removeFromRentCart, clearRentCart, setWishLists } = cartSlice.actions;
export const fetchProducts = () => async (dispatch) => {
  const { products, rentCart, total } = await getLocaData();
  dispatch(setProducts(products));
  if (rentCart) {
    dispatch(setRentCart(rentCart));
  }
  dispatch(setTotal(total));
};
export default cartSlice.reducer;